import React, { useState } from "react";
import { Filter, Search, Button, Dropdown } from "pepsico-ds";
import GridOnIcon from "@mui/icons-material/GridOn";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import { Box, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { buttonStyle } from "./InternalStyle";
import {
  setCountry,
  setFlashColor,
  setIpOwnerShip,
  setSearch,
  setSector,
} from "../../slices/internalPageSlice";

import PropTypes from "prop-types";
import "./interFilter.css";
import { handleSectorSelection } from "../../utils/function";
export default function InternalFilter({
  setGrid,
  pageData,
  header,
  setSelection,
  grid,
  showDropdown = true,
  nodata,
}) {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const dispatch = useDispatch();
  const [localSector, setLocalSector] = useState(null);
  const isDarkTheme = useSelector((state) => state.theme);

  const internalFilter = useSelector((store) => store.internalFilter);
  const { countryFilter, sectorAndCountry } = internalFilter;

  const [countries, setCountries] = useState(countryFilter);
  const filterKeyMap = {
    Sector: "sectorFilter",
    "IP Ownership": "ipOwnerShipFilter",
    "Flesh Color": "flashColorFilter",
    Variety: "varietyFilter",
    Region: "regionFilter",
    Language: "laguageFilter",
    Subject: "subjectFilter",
    "Crop Type": "cropTypeFilter",
  };
  const dropDown = pageData?.internalPageSections?.map((item) => ({
    id: item?.sectionId,
    displayText: item?.sectionName,
  }));

  const dynamicDropdowns = pageData?.internalPageLovFilterItems?.map((item) => {
    const name =
      filterKeyMap[item?.label] ||
      item?.label?.replace(/\s+/g, "")?.toLowerCase() + "Filter";

    return {
      name,
      label: item?.label || "Unknown Filter",
    };
  });

  const handleDynamicDispatch = (name, value) => {
    switch (name) {
      case "sectorFilter":
        handleSectorSelection(
          value,
          localSector,
          setLocalSector,
          dispatch,
          setCountries,
          countryFilter,
          sectorAndCountry,
          setSector
        );
        break;

      case "countryFilter":
        dispatch(setCountry(value));
        break;

      case "ipOwnerShipFilter":
        dispatch(setIpOwnerShip(value));
        break;

      case "flashColorFilter":
        dispatch(setFlashColor(value));
        break;

      default:
        break;
    }
  };

  const handleScrollToSection = (event) => {
    const { displayText } = event?.[0] || {};
    if (displayText) {
      setSelection(displayText);
    }
  };

  const handleSearch = (value) => {
    dispatch(setSearch(value));
  };

  const handleSelect = (view) => {
    setGrid(view);
  };

  return (
    <Box
      sx={
        isMobile
          ? {
              display: "flex",
              flexDirection: "column",
              gap: "24px",
              width: "100%",
            }
          : {
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }
      }
    >
      <div className="w-full">
        {!nodata && showDropdown && (
          <Box
            sx={{
              display: "flex",
              width: "100%",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Dropdown
              childList={dropDown || []}
              isClearable={false}
              placeholder="Go to Section"
              selection="single"
              setSelectedValue={handleScrollToSection}
              size="medium"
              isDark={isDarkTheme}
            />
          </Box>
        )}
        <div
          className={isMobile ? "mt-[24px]" : "flex justify-between mt-[16px]"}
          style={
            header === "Special Project" ? { justifyContent: "end" } : null
          }
        >
          {header !== "Special Project" && (
            <Box
              sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}
              className={isMobile ? "mb-[24px]" : ""}
            >
              {dynamicDropdowns?.map(({ name, label }) => {
                const options =
                  name === "countryFilter"
                    ? countries
                    : internalFilter?.[name] || [];

                return (
                  <Filter
                    key={name}
                    label={
                      <span style={{ fontSize: ".75rem", fontFamily: "Inter" }}>
                        {label}
                      </span>
                    }
                    onChange={(value) => handleDynamicDispatch(name, value)}
                    options={options?.map((item) => ({
                      id: item.id,
                      label: item.name,
                    }))}
                    selection="single"
                    size="medium"
                    isDark={isDarkTheme}
                    className="font-[Inter] text-[14px]"
                  />
                );
              })}
            </Box>
          )}
          <Box
            sx={
              isMobile
                ? { display: "flex", justifyContent: "space-between" }
                : {
                    display: "flex",
                    flexDirection: "row",
                    gap: "16px",
                    alignItems: "flex-end",
                    justifyContent: "center",
                  }
            }
          >
            <Search
              onUpdate={handleSearch}
              isDark={isDarkTheme}
              className={isMobile ? "!max-w-[272px] w-[272px]" : ""}
              style={{ marginBottom: 0 }}
            />
            <div
              className={`${
                isMobile ? "ml-[16px] mr-[16px]" : ""
              } h-[35px] bg-[#DFDFDF] w-[1px]`}
            />
            {header !== "Library" && (
              <RenderGridButtons grid={grid} handleSelect={handleSelect} />
            )}
          </Box>
        </div>
      </div>
    </Box>
  );
}
InternalFilter.propTypes = {
  setGrid: PropTypes.func.isRequired,
  pageData: PropTypes.shape({
    internalSubPages: PropTypes.objectOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        title: PropTypes.string,
        content: PropTypes.string,
      })
    ),
  }).isRequired,
  header: PropTypes.string.isRequired,
  setSelection: PropTypes.func.isRequired,
  grid: PropTypes.string.isRequired,
  showDropdown: PropTypes.bool,
  nodata: PropTypes.bool,
};

export const RenderGridButtons = ({ grid, handleSelect }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "row", gap: "8px" }}>
      <Button
        onClick={() => handleSelect("tile")}
        style={{
          ...buttonStyle,
          backgroundColor: grid === "tile" ? "#005CBC" : "transparent",
          color: grid === "tile" ? "#fff" : "#005CBC",
          border: grid === "tile" ? "none" : "1px solid #D7E5F8",
        }}
        className="mr-[8px]"
      >
        <GridOnIcon sx={{ color: grid === "tile" ? "#fff" : "#005CBC" }} />
      </Button>

      <Button
        onClick={() => handleSelect("list")}
        style={{
          ...buttonStyle,
          backgroundColor: grid !== "tile" ? "#005CBC" : "transparent",
          color: grid !== "tile" ? "#fff" : "#005CBC",
          border: grid !== "tile" ? "none" : "1px solid #D7E5F8",
        }}
      >
        <ViewListOutlinedIcon
          sx={{ color: grid !== "tile" ? "#fff" : "#005CBC" }}
        />
      </Button>
    </Box>
  );
};
